module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar img = (helpers.detectRenderedImage(model.img, model._img) || {}).rendered || {};\nvar buttonLessClass = (model.buttonText ? '' : ' buttonLess');\n%>\n<div>\n<div class=\"imagesMobile<%= buttonLessClass %>\">\n<div style=\"background-image:url(<%= img.url %>)\"></div>\n<!-- <img src=\"<%- img.url %>\" title=\"<%- img.title %>\" alt=\"<%- img.alt %>\"> -->\n</div>\n<div class=\"textsMobile<%= buttonLessClass %>\">\n<h3><%- model.title %></h3>\n<%- model.text %>\n<% if (model.buttonText) { %><%- include('../button/button', { model: model }); %><% } %>\n</div>\n</div>"
  , __filename = "components/mobile/1it-1tbb-base/1it-1tbb-base.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var img = (helpers.detectRenderedImage(model.img, model._img) || {}).rendered || {};
var buttonLessClass = (model.buttonText ? '' : ' buttonLess');

    ; __line = 4
    ; __append("\n<div>\n<div class=\"imagesMobile")
    ; __line = 6
    ; __append(escapeFn( buttonLessClass ))
    ; __append("\">\n<div style=\"background-image:url(")
    ; __line = 7
    ; __append(escapeFn( img.url ))
    ; __append(")\"></div>\n<!-- <img src=\"")
    ; __line = 8
    ; __append( img.url )
    ; __append("\" title=\"")
    ; __append( img.title )
    ; __append("\" alt=\"")
    ; __append( img.alt )
    ; __append("\"> -->\n</div>\n<div class=\"textsMobile")
    ; __line = 10
    ; __append(escapeFn( buttonLessClass ))
    ; __append("\">\n<h3>")
    ; __line = 11
    ; __append( model.title )
    ; __append("</h3>\n")
    ; __line = 12
    ; __append( model.text )
    ; __append("\n")
    ; __line = 13
    ;  if (model.buttonText) { 
    ; __append( include('../button/button', { model: model }) )
    ;  } 
    ; __append("\n</div>\n</div>")
    ; __line = 15
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/mobile/1it-1tbb-base/1it-1tbb-base.ejs

}